import { Spin } from '@faceup/ui-base'

export const FullPageSpin = () => (
  <div className='flex justify-center items-center h-[100vh] w-full'>
    <Spin size='large' />
  </div>
)
